import { Badge } from '@/components/ui/badge';
import { Loader2 } from 'lucide-react';
import type { ProjectStatus } from '../types';

const statusConfig: Record<ProjectStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline'; animate?: boolean }> = {
  draft: { label: 'Brouillon', variant: 'secondary' },
  analyzing: { label: 'Analyse...', variant: 'default', animate: true },
  analysis_failed: { label: 'Analyse échouée', variant: 'destructive' },
  ready: { label: 'Prêt', variant: 'default' },
  running: { label: 'En cours', variant: 'warning' },
  paused: { label: 'En pause', variant: 'outline' },
  completed: { label: 'Terminé', variant: 'success' },
  failed: { label: 'Échoué', variant: 'destructive' },
  reset: { label: 'Réinitialisé', variant: 'secondary' },
};

interface ProjectStatusBadgeProps {
  status: ProjectStatus;
  className?: string;
}

export function ProjectStatusBadge({ status, className }: ProjectStatusBadgeProps) {
  const config = statusConfig[status] ?? { label: status, variant: 'secondary' as const };

  return (
    <Badge variant={config.variant} className={className}>
      {config.animate && <Loader2 className="h-3 w-3 animate-spin mr-1" />}
      {config.label}
    </Badge>
  );
}
